import { CartIconStore } from './cartIconStore';
import { withErrorReporting } from '@wix/wixstores-client-core/dist/es/src/viewer-script/errorReporter';
import { specs } from '../constants';
export function cartWidgetController(controllerFactoryConfig) {
    var cartIconStore;
    var siteStore;
    var compId = controllerFactoryConfig.compId, config = controllerFactoryConfig.config, platformAPIs = controllerFactoryConfig.platformAPIs, setProps = controllerFactoryConfig.setProps, factoryContext = controllerFactoryConfig.context, reportError = controllerFactoryConfig.reportError;
    return {
        pageReady: function () {
            siteStore = factoryContext.siteStore;
            cartIconStore = new CartIconStore(siteStore, config, compId, setProps, reportError, platformAPIs);
            return cartIconStore.setInitialState();
        },
        updateConfig: function (_$w, updatedConfig) {
            config.style = updatedConfig.style;
            config.publicData = updatedConfig.publicData;
            setProps({ displayText: cartIconStore.getDisplayText({}) });
        },
        onBeforeUnLoad: function () {
            cartIconStore.unSubscribeAll();
        },
        exports: function () {
            return withErrorReporting(controllerFactoryConfig.reportError)({
                addToCart: function (productId, quantity, options) {
                    if (quantity === void 0) { quantity = 1; }
                    if (options === void 0) { options = {}; }
                    if (siteStore.experiments.enabled(specs.stores.WixCodeAddItemsToCart) && Array.isArray(productId)) {
                        var addToCartItems = productId;
                        return cartIconStore.addItemsToCart(addToCartItems);
                    }
                    else {
                        //tslint:disable-line
                        return cartIconStore.addToCart("" + productId, quantity, options);
                    }
                },
            });
        },
    };
}
//# sourceMappingURL=cartIconController.js.map